import { Button, Group, Stack, Text } from '@mantine/core';
import { modals } from '@mantine/modals';
import type { TFunction } from 'i18next';

const TRANS_KEY = 'EDIT_COMPANY_LINK_FORM.HANDLE_CONNECTED_ARTISTS_MODAL';

type UpdateCompanyLinkTypeHandleConnectedArtists = 'TRANSFER' | 'DELETE';

export const openConnectedArtistsChoiceModal = (
  t: TFunction<'common'>
): Promise<UpdateCompanyLinkTypeHandleConnectedArtists> => {
  return new Promise((resolve, reject) => {
    const id = modals.open({
      title: t(`${TRANS_KEY}.TITLE`),
      size: 'md',
      onClose: reject,
      children: (
        <Stack gap="md">
          <Text size="sm">{t(`${TRANS_KEY}.DESCRIPTION`)}</Text>
          <Group justify="flex-end" gap="sm" wrap="nowrap">
            <Button
              onClick={() => {
                resolve('TRANSFER');
                modals.close(id);
              }}
            >
              {t(`${TRANS_KEY}.TRANSFER_BUTTON`)}
            </Button>
            <Button
              color="red"
              onClick={() => {
                resolve('DELETE');
                modals.close(id);
              }}
            >
              {t(`${TRANS_KEY}.DELETE_BUTTON`)}
            </Button>
          </Group>
        </Stack>
      ),
    });
  });
};
